import { render, staticRenderFns } from "./UploadFileAttachGroup.vue?vue&type=template&id=2755b1ce&scoped=true"
import script from "./UploadFileAttachGroup.vue?vue&type=script&lang=js"
export * from "./UploadFileAttachGroup.vue?vue&type=script&lang=js"
import style0 from "./UploadFileAttachGroup.vue?vue&type=style&index=0&id=2755b1ce&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2755b1ce",
  null
  
)

export default component.exports